import { Paper, PaperProps } from "@mui/material";

export const CustomPaper = (props: PaperProps) => {
    return <Paper {...props} sx={{ margin: '7px 0', ...props.sx ?? {}}} />;
  };